<div class="wiring-instructions__container">
  <!-- All wiring instructions details -->
  <div class="wiring-instructions__all-details">
    <div *ngFor="let instruction of processedInstructions; let i = index">
      <!-- Instructions for regular fields -->
      <ng-container *ngIf="instruction.fields && instruction.fields.length > 0">
        <div class="wiring-instructions__details">
          <ng-container *ngFor="let field of instruction.fields">
            <!-- Value-only field (no label) -->
            <div *ngIf="field.name === '_no_label_' && showSupplementary" class="wiring-instructions__no-label">
              {{ field.value }}
            </div>

            <!-- Regular label-value rows -->
            <div *ngIf="field.name !== '_no_label_'" class="wiring-instructions__row">
              <div class="wiring-instructions__label">
                <span>{{ 'contribute.confirmation.' + field.name | translateLang }}</span>
                <div *ngIf="isWireRoutingNumber(field.name)" class="wiring-instructions__label-optional">
                  {{ 'contribute.confirmation.donate.wire.routing.number.optional' | translateLang }}
                </div>
              </div>
              <div class="wiring-instructions__value">{{ field.value }}</div>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <!-- Instructions for instructionsSets (Swiss USD format) -->
      <ng-container *ngIf="instruction.instructionsSets && instruction.instructionsSets.length > 0">
        <div *ngFor="let set of instruction.instructionsSets" class="wiring-instructions__set">
          <div class="wiring-instructions__details">
            <div class="wiring-instructions__row" *ngFor="let field of set">
              <div class="wiring-instructions__label">
                <span>{{ 'contribute.confirmation.' + field.name | translateLang }}</span>
                <div *ngIf="isWireRoutingNumber(field.name)" class="wiring-instructions__label-optional">
                  {{ 'contribute.confirmation.donate.wire.routing.number.optional' | translateLang }}
                </div>
              </div>
              <div class="wiring-instructions__value">{{ field.value }}</div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Warning Banner for Notes -->
      <div *ngIf="hasNote(i)" class="wiring-instructions__warning">
        <svg class="wiring-instructions__warning-icon"
             viewBox="0 0 24 30"
             fill="none"
             xmlns="http://www.w3.org/2000/svg"
             aria-hidden="true">
          <circle cx="12" cy="15" r="10" stroke="currentColor" stroke-width="2"/>
          <path d="M12 10v6m0 4h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <div class="wiring-instructions__warning-text">{{ getNote(i) }}</div>
      </div>

      <!-- Separator between multiple instructions -->
      <hr *ngIf="processedInstructions.length > 1 && i + 1 < processedInstructions.length" class="wiring-instructions__separator" />
    </div>
  </div>
</div>
